(() => {
  let showBannerTimeout = setTimeout(() => {}, 1);
  let hideBannerTimeout = setTimeout(() => {}, 1);
  let currentHideBannerTimeoutDuration = 6000;
  let COMPARE_ALLOWED = true;

  const plugMap = {
    '5-20R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_20A_GFCI_Outlet.png?v=1612382967',
      name: '120v 20 Amp Standard Receptacle',
    },
    'L5-30R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_30A_Twist_Lock.png?v=1612382967',
      name: '120v 30 Amp Twist Lock',
    },
    'L14-30R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_30A_Twist_Lock.png?v=1612382967',
      name: '120/240v 30 Amp Twist Lock',
    },
    'L14-50R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_50A_Heavy_Duty_Outlet.png?v=1612382967',
      name: '120v/240v 50 Amp Heavy Duty Outlet',
    },
    '14-50R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_50A_Heavy_Duty_Outlet.png?v=1612382967',
      name: '120v/240v 50 Amp Heavy Duty Outlet',
    },
    'TT-30R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_TT-30R.png?v=1612813988',
      name: '120v 30 Amp RV Ready',
    },
    'L14-20R': {
      image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/125V_250V_20_Amp_Twist_Lock.png?v=1613276582',
      name: '125v/250v 20 Amp Twist Lock',
    },
  };
  const LIMIT = 20;
  const filtersContainer = document.querySelector('.collection__filters');
  const sortContainer = document.querySelector('.collection__sorters');
  const compareProductsContainer = document.querySelector('.collection__compare-products');
  const productCountContainer = document.querySelector('.collection__product-count');
  const collectionGrid = document.querySelector('.js-collection-grid');
  const loadMoreBtn = document.querySelector('.js-load-more');
  // const BASE_URL = `https://www.fpapplications.com/v2/collections?currency=${CURRENCY_CODE}&id=${window.collection_id}&limit=${LIMIT}`;
  // const BASE_URL = `http://localhost:8082/v2/collections?currency=${CURRENCY_CODE}&id=${window.collection_id}&limit=${LIMIT}`;
  const BASE_URL = `https://www.fpapplications.com/v2/collections?currency=${CURRENCY_CODE}&id=${window.collection_id}&limit=${LIMIT}`;
  const BASE_COLLECTION_INFO = {
    lowestPrice: 0,
    highestPrice: 0,
    handle: window.collection_handle,
  };
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  // const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
  init();

  function init() {
    const fetchUrl = buildFetchFromParams();
    (window.COLLECTION_PROMISE || fetch(fetchUrl))
      .then((res) => res.json())
      .then((res) => {
        if (!res.success) {
          filtersContainer.innerHTML = '';
          sortContainer.innerHTML = '';
          collectionGrid.innerHTML = '';
          productCountContainer.innerText = '';
          toggleNoCollectionResults(true);
          return;
        }
        const {
          filters: { collection_size, filters, price_range, vendors },
          products,
        } = res;
        if (products.length === 0) {
          toggleNoCollectionResults(true);
        }

        BASE_COLLECTION_INFO.lowestPrice = Math.floor(price_range[0]);
        BASE_COLLECTION_INFO.highestPrice = Math.floor(price_range[1]) + 1;

        // Filters
        const priceFilter = renderPriceFilter(BASE_COLLECTION_INFO.lowestPrice, BASE_COLLECTION_INFO.highestPrice);
        const brandFilter = renderVendorFilter(vendors);
        const ratingFilter = renderReviewsFilter();
        const otherFilters = Object.entries(filters)
          .map(([group_name, { type, values, unit, disjunctive }]) => {
            if (type === 'checkbox') {
              return renderCheckboxFilter({ group_name, values, disjunctive });
            }
            if (type === 'radio') {
              return renderRadioFilter({ group_name, values });
            }
            if (type === 'range') {
              return renderRangeFilter({ group_name, values, unit });
            }
          })
          .join('\n');
        filtersContainer.innerHTML = `${priceFilter}\n${brandFilter}\n${ratingFilter}\n${otherFilters}\n${renderApplyFilterButton()}`;

        // Sorters
        sortContainer.innerHTML = buildSorters();

        // Compare Bar
        compareProductsContainer.innerHTML = buildCompareBar();

        const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
        if (selectedCompareProducts.length === 0) {
          compareProductsContainer.style.display = 'none';
        }

        // Product count
        productCountContainer.innerText = `${collection_size} Products`;

        // Cards
        collectionGrid.innerHTML = '';
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          collectionGrid.innerHTML += renderCard(product, i === 0 ? 'eager' : 'lazy');
        }
        loadMoreBtn.innerText = 'LOAD MORE';
        if (products.length < LIMIT) {
          loadMoreBtn.style.display = 'none';
        } else {
          loadMoreBtn.style.display = '';
        }
        checkActiveBoxesFromParams(getParams());
        buildActiveFilters();
        listen();
        listenToCompareBar();
        listenToWishlistContainer();
        listenToCompareCheckboxes();
        addAndRemoveFromWishlist();
        checkForCompareAllowed();
      });
  }

  function checkForCompareAllowed() {
    fetch(`https://www.fpapplications.com/comparison/check/collections/${window.collection_id}`)
      .then((res) => res.json())
      .then((res) => {
        if (!res.success) {
          return;
        }
        if (!res.has_comparison_fields) {
          COMPARE_ALLOWED = false;
          for (const addToCompare of Array.from(document.querySelectorAll('.collection__compare__container'))) {
            addToCompare.style.display = 'none';
          }
        }
      })
      .catch(console.error);
  }

  function fetchAndRenderCards({ reset, page } = {}) {
    const currentFetchUrl = buildFetchFromBoxes(page);
    buildActiveFilters();
    fetch(currentFetchUrl)
      .then((res) => res.json())
      .then((res) => {
        const { products } = res;
        loadMoreBtn.innerText = 'LOAD MORE';
        if (products.length < LIMIT) {
          loadMoreBtn.style.display = 'none';
        } else {
          loadMoreBtn.style.display = '';
        }
        if (!products.length) {
          toggleNoFilteredResults(true);
        } else {
          toggleNoFilteredResults(false);
        }
        let newString = '';
        for (const product of products) {
          newString += renderCard(product);
        }
        if (reset) {
          document.querySelector('.collection__grid').innerHTML = newString;
        } else {
          document.querySelector('.collection__grid').innerHTML += newString;
        }
        listenToCompareBar();
        listenToWishlistContainer();
        listenToCompareCheckboxes();
        addAndRemoveFromWishlist();
        window.wishlistHelper?.check();
      });
  }
  function renderApplyFilterButton() {
    return `<button class="collection__filters__apply js-filter-apply">SHOW PRODUCTS</button>`;
  }
  function renderCard(
    {
      title,
      price,
      compare_at_price,
      judgeme_badge,
      inventory_quantity,
      inventory_policy,
      tracks_inventory,
      handle,
      product_pdp_line_1,
      product_pdp_line_2,
      collection_pdp_line_1,
      collection_pdp_line_2,
      features,
      featured_image,
      id,
      sku,
    },
    loading = 'lazy'
  ) {
    let onSale = false;
    let shipping_message = 'Ships same or next day';
    if (
      (collection_pdp_line_1 && collection_pdp_line_1.includes(':')) ||
      (collection_pdp_line_1 && collection_pdp_line_1.includes('ADD TO CART'))
    ) {
      onSale = true;
      shipping_message = collection_pdp_line_2;
    } else if (collection_pdp_line_1) {
      onSale = false;
      shipping_message = collection_pdp_line_1;
    }
    if (
      (product_pdp_line_1 && product_pdp_line_1.includes(':')) ||
      (product_pdp_line_1 && product_pdp_line_1.includes('ADD TO CART'))
    ) {
      onSale = true;
      shipping_message = product_pdp_line_2;
    } else if (product_pdp_line_1) {
      onSale = false;
      shipping_message = product_pdp_line_1;
    }
    if (compare_at_price) {
      onSale = true;
    }
    const stock =
      inventory_quantity < 1 && inventory_policy == 'deny' && tracks_inventory === 1
        ? 'OOS'
        : inventory_quantity < 1 && inventory_policy == 'continue' && tracks_inventory === 1
        ? 'PRE'
        : 'INSTOCK';
    const featuresArray = (features || '').split(',').filter((v) => v);

    return `
        <div class="collection__card">
          <a href="/products/${handle}" style='display: block;' class="collection__card__image-container">
              <img
              class="collection__card__img"
              src="${featured_image}&width=400"
              alt="${title}"
              width="400"
              height="400"
              loading="${loading}"
              >
          </a>
          
          <div class="collection__card__content">
              <div class="collection__card__upper">
                  <a href="/products/${handle}" style='cursor: pointer;' class="collection__card__heading">${title}</a>
                  ${judgeme_badge}
                    <div class="collection__card__price-box">
                        <p class="collection__card__price">${moneyFormatter.format(price).replace('.00', '')}</p>
                        ${
                          compare_at_price ? `<p class="collection__card__price--compare">$${compare_at_price}</p>` : ''
                        }
                        <div class="collection__card__free-shipping">
                            <div class="collection__card__free-shipping__image-container">
                                <img style="width:100%; height: 100%; display: block;" src="https://cdn.shopify.com/s/files/1/1163/1976/files/shipping-box.png?v=1607959434" alt="shipping box" width="50" height="50" loading="lazy" role='none'>
                            </div>
                            <div class="collection__card__free-shipping__text">
                                FREE Shipping
                            </div>
                        </div>
                    </div>
              </div>
              ${
                onSale && stock !== 'OOS'
                  ? '<div class="collection__card__sale"><div class="collection__card__sale__inner">SALE</div></div>'
                  : ''
              }
              ${
                stock === 'OOS'
                  ? '<div class="outofstock">OUT OF STOCK</div>'
                  : stock === 'PRE'
                  ? '<div class="preorder"><img class="pdp__main__stock__box__upper__icon__img" src="https://cdn.shopify.com/s/files/1/1163/1976/files/preorder-icon_789aaab2-b3fc-4fa8-b2b8-e5e2ec722858.png?v=1665510873" alt="pre-order icon" width="18" height="18" loading="lazy"/>Pre-order</div>'
                  : ''
              }
              <div>
              <div class="collection__card__lower">
                  <p class="collection__card__shipping">${shipping_message.split('- Free')[0].trim()}</p>
                  ${
                    featuresArray.length > 0
                      ? `
                      <div class="collection__card__features">
                          <p class="collection__card__features__heading">Features:</p>
                          <p class="collection__card__features__list">${featuresArray.join(', ')}</p>
                      </div>
                  `
                      : ''
                  }
              </div>
          </div>
      
          <div class="collection__compare--compare__and__favorite">
            <div class="collection__compare__container" ${!COMPARE_ALLOWED ? 'style="display: none"' : ''}>
              <label for="${id}-compareCheckboxid" class="compareCheckbox" tabindex='0'>Compare
                  <input
                    class="js-compareCheckbox"
                    type="checkbox"
                    id="${id}-compareCheckboxid"
                    data-checkboxid="${id}"
                    value="${id}|${escapeSpecialCharacters(title)}|${escapeSpecialCharacters(
      featured_image
    )}|${escapeSpecialCharacters(handle)}|${sku}"
                  />
              <span class="checkmark"></span>
              </label>
            </div>
            <button class='add__fav--collection__button js-add__fav override__default__button__styles' data-id=${id} id='emptyHeart${id}' data-empty='${id}' role='button' aria-label='add to Wishlist' tabindex='0'>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink" 
                fill="#308628" 
                width="100%" 
                height="100%" 
                version="1.1" 
                id="Layer_1" 
                viewBox="0 0 512.021 512.021" 
                xml:space="preserve"
              >
              <desc>outlined heart icon</desc>
                <g>
                  <g>
                    <path d="M471.19,53.898c-26.288-26.8-61.648-41.568-99.584-41.568c-35.728,0-68.848,13.104-95.792,37.92l-19.936,18.432    L236.23,49.77c-24.736-23.84-58.672-36.976-95.584-36.976c-39.264,0-74.88,14.848-100.304,41.824    c-53.728,57.232-53.792,148.08-0.176,206.784L256.374,499.69l215.44-238C525.606,202.81,525.446,111.658,471.19,53.898z     M448.15,240.154L256.342,452.042L63.83,239.866c-42.448-46.464-42.512-118.208-0.16-163.312    C82.966,56.09,110.294,44.81,140.662,44.81c28.576,0,54.64,9.952,73.392,28.016l41.408,39.824l42.064-38.88    c20.912-19.248,46.528-29.44,74.096-29.44c29.264,0,56.512,11.36,76.496,31.712C490.742,121.434,490.774,193.498,448.15,240.154z"/>
                  </g>
                </g>
              </svg>
            </button>
            <button class='remove__fav--collection__button js-remove__fav override__default__button__styles' data-id=${id} id='filledHeart${id}' data-filled='${id}' role='button' aria-label='remove from Wishlist' tabindex='0'>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink" 
                xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" 
                width="100%" 
                height="100%" 
                viewBox="0 -1 32 32" 
                version="1.1"
              >
                  <defs></defs>
                  <desc>Filled in heart icon</desc>
                  <g 
                    id="Page-1" 
                    stroke="none" 
                    stroke-width="1" 
                    fill="none" 
                    fill-rule="evenodd" 
                    sketch:type="MSPage"
                  >
                    <g 
                      id="Icon-Set-Filled" 
                      sketch:type="MSLayerGroup" 
                      transform="translate(-102.000000, -882.000000)" 
                      fill="#308628"
                    >
                      <path d="M126,882 C122.667,882 119.982,883.842 117.969,886.235 C116.013,883.76 113.333,882 110,882 C105.306,882 102,886.036 102,890.438 C102,892.799 102.967,894.499 104.026,896.097 L116.459,911.003 C117.854,912.312 118.118,912.312 119.513,911.003 L131.974,896.097 C133.22,894.499 134,892.799 134,890.438 C134,886.036 130.694,882 126,882" id="heart-like" sketch:type="MSShapeGroup">
                      </path>
                    </g>
                  </g>
              </svg>
            </button>

          </div>
        </div>
      </div>
    </div>
    <div class='favorites__banner--container'>
      <div class='favorites__banner not__signed__in'>
        <div style='text-align: center; margin: 6px 0 0 0; display: flex; overflow: wrap;'>
          <a href='/account/login'><u>Sign in or Create an account</u>&nbsp;to keep your wishlist.</a>
        </div>
        <a href="/pages/customer-favorites">
          <div class='view__favorites--button__wrapper'>
            <div class='view__wishlist--button'>View wishlist</div>
          </div>
        </a>
      </div>

      <div class='favorites__banner signed__in'>
        <div style='text-align: center; margin: 6px 0 0 0;'>Product successfully added to your wishlist.</div>
        <a href="/pages/customer-favorites">
          <div class='view__favorites--button__wrapper'>
            <div class='view__wishlist--button'>View wishlist</div>
          </div>
        </a>
      </div>
    </div>
      `;
  }

  async function addAndRemoveFromWishlist() {
    const detectDeviceType = () => (/Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop');
    const emptyHeartIcons = Array.from(document.querySelectorAll('.js-add__fav'));
    // window.wishlistHelper?.refresh();
    window.wishlistHelper?.check();
    const userData = JSON.parse(localStorage.getItem('userData'));

    // FAVORITES FETCH //
    for (const emptyHeartIcon of emptyHeartIcons) {
      emptyHeartIcon.addEventListener('click', () => {
        // fetch('http://localhost:8082/customerFavorites', {
        fetch('https://www.fpapplications.com/customerFavorites', {
          method: 'POST',
          body: JSON.stringify({
            customer_id: CUSTOMER_ID,
            session_id: SESSION_ID,
            product_id: emptyHeartIcon.dataset.empty,
            city: userData.city,
            state: userData.region,
            device_type: detectDeviceType(),
            user_agent: window.navigator.userAgent,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              window.wishlistHelper?.refresh();
              emptyHeartIcon.style.display = 'none';
              emptyHeartIcon.nextElementSibling.style.display = 'flex';
              document.querySelector('.favorites__banner--container').style.display = 'block';
              clearTimeout(showBannerTimeout);
              clearTimeout(hideBannerTimeout);
              showBannerTimeout = setTimeout(() => {
                document.querySelector('.favorites__banner--container').classList.add('favorites__banner--visible');
                document.querySelector('.not__signed__in').style.display = 'none';
              }, 1);
              hideBannerTimeout = setTimeout(() => {
                document.querySelector('.favorites__banner--container').classList.remove('favorites__banner--visible');
              }, currentHideBannerTimeoutDuration);
            }
          });
      });
    }

    const filledHeartIcons = Array.from(document.querySelectorAll('.js-remove__fav'));

    for (const filledHeartIcon of filledHeartIcons) {
      filledHeartIcon.addEventListener('click', () => {
        // fetch('http://localhost:8082/customerFavorites', {
        fetch('https://www.fpapplications.com/customerFavorites', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            customer_id: CUSTOMER_ID,
            session_id: SESSION_ID,
            product_id: filledHeartIcon.dataset.filled,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              window.wishlistHelper?.refresh();
              filledHeartIcon.style.display = 'none';
              filledHeartIcon.previousElementSibling.style.display = 'flex';
            }
          });
      });
    }
  }

  function escapeSpecialCharacters(str) {
    return str.replaceAll('"', '&quot;').replaceAll("'", '&#39;');
  }

  function renderPriceFilter(lowestPrice, highestPrice) {
    return `
          <div class="collection__filters__container">
              <button class="collection__filters__button js-filter-toggle">Price</button>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                    <div 
                      class="range-slider js-range-slider"
                      data-group-name="Price"
                      data-min="${lowestPrice}"
                      data-max="${highestPrice}"
                    >
                      <div class="range-slider__inner">
                        <input
                          id="min-Price"
                          name="min-Price"
                          type="range"
                          min="${lowestPrice}"
                          max="${highestPrice}"
                          value="${lowestPrice}"
                          step="1"
                          class="range-slider__input"
                        />
                        <label for="min-Price" class="range-slider__display range-slider__display--low">
                          <span class="range-slider__amount">${moneyFormatter.format(lowestPrice)}</span>
                          <span class="range-slider__unit"></span>
                        </label>
                        <input
                          id="max-Price"
                          name="max-Price"
                          type="range"
                          min="${lowestPrice}"
                          max="${highestPrice}"
                          value="${highestPrice}"
                          step="1"
                          class="range-slider__input"
                        />
                        <label for="max-Price" class="range-slider__display range-slider__display--high">
                          <span class="range-slider__amount">${moneyFormatter.format(highestPrice)}</span>
                          <span class="range-slider__unit"></span>
                        </label>
                      </div>
                    </div>  
                    <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }
  function renderRangeFilter({ group_name, values, unit }) {
    const [low, high] = values;
    if (group_name === 'Peak Wattage') {
      return '';
    }
    return `
          <div class="collection__filters__container">
              <button class="collection__filters__button js-filter-toggle">${group_name}</button>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                    <div 
                      class="range-slider js-range-slider"
                      data-group-name="${group_name}"
                      data-min="0"
                      data-max="${high}"
                    >
                      <div class="range-slider__inner">
                        <input
                          id="min-${group_name}"
                          type="range"
                          min="0"
                          max="${high}"
                          value="0"
                          step="${high / 100}"
                          class="range-slider__input"
                        />
                        <label for="min-${group_name}" class="range-slider__display range-slider__display--low">
                          <span class="range-slider__amount">0</span>
                          <span class="range-slider__unit">${unit}</span>
                        </label>
                        <input
                          id="max-${group_name}"
                          type="range"
                          min="0"
                          max="${high}"
                          value="${high}"
                          step="${high / 100}"
                          class="range-slider__input"
                        />
                        <label for="max-${group_name}" class="range-slider__display range-slider__display--high">
                          <span class="range-slider__amount">${high}</span>
                          <span class="range-slider__unit">${unit}</span>
                        </label>
                      </div>
                    </div>  
                    <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }
  function renderCheckboxFilter({ group_name, values, disjunctive }) {
    const joiner = disjunctive ? 'd' : 'c';
    return `
          <div class="collection__filters__container">
              <button class="collection__filters__button js-filter-toggle">${group_name}</button>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                      <div class="collection__filters__content__options">
                          ${values
                            .sort((a, b) => {
                              return a < b ? -1 : 1;
                            })
                            .map((value) => {
                              const plug = plugMap[value];
                              return `
                                  <div class="collection__filters__checkbox">
                                  ${
                                    plug
                                      ? `<img 
                                          src="${plug.image_url}" 
                                          alt="${plug.name}" 
                                          style="pointer-events: none; width: 48px; height: 48px; position: relative; z-index: 2; margin: 0 auto 8px; display: block;" 
                                          width="auto"
                                          height="auto"
                                          loading="lazy"
                                        />`
                                      : ''
                                  }
                                      <input 
                                          class="collection__filters__checkbox__input js-tag"
                                          type="checkbox" 
                                          id="${group_name}-${value}" 
                                          value="${joiner}__${group_name}__${value}"
                                      />
                                      <label class="collection__filters__checkbox__label" for="${group_name}-${value}">${
                                BASE_COLLECTION_INFO.handle === 'standby' && value === 'Liquid Propane'
                                  ? 'Liquid Propane or Natural Gas'
                                  : value
                              }</label>
                                  </div>
                                  `;
                            })
                            .join('\n')}
                      </div>
                      <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }
  function renderVendorFilter(vendors) {
    if (!vendors.length) {
      return '';
    }
    return `
          <div class="collection__filters__container">
              <button class="collection__filters__button js-filter-toggle">Brand</button>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                      <div class="collection__filters__content__options">
                          ${vendors
                            .sort((a, b) => {
                              return a < b ? -1 : 1;
                            })
                            .map((vendor) => {
                              return `
                                  <div class="collection__filters__checkbox">
                                      <input 
                                          class="collection__filters__checkbox__input js-vendor"
                                          type="checkbox" 
                                          id="vendor-${vendor}" 
                                          value="${vendor}"
                                      />
                                      <label class="collection__filters__checkbox__label" for="vendor-${vendor}">
                                          ${vendor}
                                      </label>
                                  </div>
                                  `;
                            })
                            .join('\n')}
                      </div>
                      <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }
  function renderRadioFilter({ group_name, values }) {
    return `
          <div class="collection__filters__container>
              <h2 class="collection__filters__button js-filter-toggle>${group_name}</h2>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                      <div class="collection__filters__content__options">
                          ${values
                            .sort((a, b) => {
                              return a < b ? -1 : 1;
                            })
                            .map((value) => {
                              return `
                                      <div style="display: flex; gap: 8px;">
                                          <input class="js-tag" type="radio" name="${group_name}" id="${group_name}-${value}" value="d__${group_name}__${value}">
                                          <label class="collection__filters__checkbox__label" for="${group_name}-${value}">${value}</label>
                                      </div>
                                  `;
                            })
                            .join('\n')}
                      </div>
                      <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }
  function renderReviewsFilter() {
    return `
          <div class="collection__filters__container">
              <button class="collection__filters__button js-filter-toggle">Review Rating</button>
              <div class="collection__filters__content">
                  <div class="collection__filters__content__inner">
                      <div class="collection__filters__content__options">
                          <div class="collection__filters__stars">
                              <input class="collection__filters__stars__input" type="radio" name="review_rating" id="three-stars" value="3" />
                              <label class="collection__filters__stars__label" for="three-stars">3 Star &amp; Up</label>
                              <span class="jdgm-prev-badge__stars"> 
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--off"></span>
                                  <span class="jdgm-star jdgm--off"></span> 
                              </span>
                          </div>
                          <div class="collection__filters__stars">
                              <input class="collection__filters__stars__input" type="radio" name="review_rating" id="four-stars" value="4" />
                              <label class="collection__filters__stars__label" for="four-stars">4 Star &amp; Up</label>
                              <span class="jdgm-prev-badge__stars"> 
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--off"></span> 
                              </span>
                          </div>
                          <div class="collection__filters__stars">
                              <input class="collection__filters__stars__input" type="radio" name="review_rating" id="five-stars" value="5" />
                              <label class="collection__filters__stars__label" for="five-stars">5 Star</label>
                              <span class="jdgm-prev-badge__stars"> 
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span>
                                  <span class="jdgm-star jdgm--on"></span> 
                              </span>
                          </div>
                      </div>
                      <button class="collection__filters__close js-filter-close-desktop">CLOSE</button>
                  </div>
              </div>
          </div>
      `;
  }

  function buildSorters() {
    return `
        <div class="collection__sort__select__container">
            <label 
              for="collection-sort-select" 
              style="position: absolute; width: 0; height: 0; overflow: hidden; z-index: -5;"
            >
              Sort Results
            </label>
            <select id="collection-sort-select" class="collection__sort__select">
                <option value="rank-asc">Best Selling</option>
                <option value="price-asc">Price (low - high)</option>
                <option value="price-desc">Price (high - low)</option>
                <option value="alpha-asc">Alphabetically (A - Z)</option>
                <option value="alpha-desc">Alphabetically (Z - A)</option>
            </select>
            <div class="collection__sort__select__overlay">&nbsp;</div>
        </div>
    `;
  }

  function updateCompareBar() {
    const compareProductsContainer = document.querySelector('.collection__compare-products');
    const compareElementsAnchor = document.querySelector('.js-compare-elements-anchor');

    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    const compareMap = selectedCompareProducts.map((compare) => ({
      featured_image: compare.featured_image,
      id: compare.id,
      handle: compare.handle,
      title: compare.title,
      sku: compare.sku,
    }));
    compareElementsAnchor.innerHTML = `<p class="collection__compare__bar--text">
           ${
             selectedCompareProducts.length > 1
               ? `<p class="collection__compare__bar--text compare__selected">
                   ${selectedCompareProducts.length} selected
                 </p>`
               : `<p class="collection__compare__bar--text compare__selected">
               Compare up to 10 products
                 </p>`
           }
           <div class="collection__compare__bar--flex">
             ${compareMap
               .map(
                 (compare) => `<div class='compare__and__sku--container'>
                                  <div class='compare__and__sku--wrapper'>
                                    <div class="collection__compare__bar--images">
                                      <a href="/products/${compare.handle}">
                                        <img src=${compare.featured_image} class="collection__compare__bar--selected__product" alt='${compare.title}'/>
                                      </a>
                                        <div style='position:relative; top-0; left-[8px];'>
                                        <button class="collection__compare__bar--x js-removeProductFromCompare" data-id="${compare.id}" id="${compare.id}-removeProductFromCompare" aria-label='remove from compare list'>
                                          <svg 
                                            xmlns="http://www.w3.org/2000/svg" 
                                            fill="#575757" 
                                            width="100%" 
                                            height="100%" 
                                            version="1.1" 
                                            viewBox="144 144 512 512" 
                                            aria-label='x icon'
                                          >
                                            <path d="m563.32 236.68c-26.852-26.84-59.91-46.645-96.246-57.66-36.336-11.016-74.828-12.902-112.07-5.4922-37.238 7.4102-72.074 23.891-101.42 47.977-29.348 24.086-52.305 55.039-66.84 90.117-14.531 35.078-20.188 73.199-16.469 110.98 3.7148 37.785 16.691 74.07 37.781 105.64 21.086 31.574 49.637 57.461 83.117 75.367s70.859 27.281 108.83 27.293c61.219 0.078125 119.96-24.16 163.32-67.383 21.484-21.449 38.531-46.922 50.16-74.965 11.629-28.043 17.617-58.102 17.617-88.461 0-30.355-5.9883-60.418-17.617-88.457-11.629-28.043-28.676-53.516-50.16-74.965zm-74.312 222.73c3.9102 3.9336 6.1055 9.2539 6.1055 14.801 0 5.543-2.1953 10.863-6.1055 14.797-3.9297 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055l-59.406-59.406-59.41 59.406c-3.9336 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055-3.9102-3.9336-6.1055-9.2539-6.1055-14.797 0-5.5469 2.1953-10.867 6.1055-14.801l59.406-59.406-59.406-59.41c-3.4375-4.0156-5.2344-9.1797-5.0312-14.465 0.20312-5.2812 2.3945-10.293 6.1328-14.031s8.75-5.9297 14.031-6.1328c5.2852-0.20313 10.449 1.5938 14.465 5.0312l59.41 59.406 59.406-59.406c1.8828-2.1992 4.1992-3.9805 6.8008-5.2422 2.6055-1.2617 5.4414-1.9688 8.3359-2.0781 2.8906-0.11328 5.7695 0.375 8.4648 1.4297 2.6953 1.0547 5.1406 2.6562 7.1875 4.7031 2.043 2.043 3.6445 4.4922 4.7031 7.1836 1.0508 2.6953 1.5391 5.5781 1.4297 8.4688-0.11328 2.8906-0.82031 5.7266-2.082 8.332-1.2578 2.6055-3.043 4.9219-5.2422 6.8008l-59.406 59.41z"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                    <div class='product__identifier--collection' aria-label='SKU'>${compare.sku}</div>
                                   </div>
                              </div>`
               )
               .join('\n')}
               ${
                 selectedCompareProducts.length > 5
                   ? `<div class="collection__compare__bar--five__items__showing">+${
                       selectedCompareProducts.length - 5
                     }</div>`
                   : ''
               }
               ${
                 selectedCompareProducts.length > 2
                   ? `<div class="collection__compare__bar--two__items__showing">+${
                       selectedCompareProducts.length - 2
                     }</div>`
                   : ''
               }
              ${
                selectedCompareProducts.length > 1
                  ? `<div class="collection__compare__bar--one__item__showing">+${
                      selectedCompareProducts.length - 1
                    }</div>`
                  : ''
              }
              <div style='display: flex; gap: 10px;'>
                <button class='collection__compare__bar--products__button js-compareButton' tabindex='0'>Compare</button>
                <button class='collection__compare__bar--products__button js-hideCompareButton' tabindex='0'>Hide</button>
              </div>
   `;
    listenToCompareBar();

    /* uncheck product when it is removed from selection list with x button */
    const checkboxes = Array.from(document.querySelectorAll('.js-compareCheckbox'));
    for (const checkbox of checkboxes) {
      const foundProduct = selectedCompareProducts.find((product) => {
        return product.id === checkbox.dataset.checkboxid;
      });
      if (!foundProduct) {
        checkbox.checked = false;
      }
    }
    /* only display compare bar if an item is selected */
    if (selectedCompareProducts.length === 0) {
      compareProductsContainer.style.display = 'none';
      window.compareBanner?.refresh();
    } else {
      compareProductsContainer.style.display = '';
    }
  }

  window.compare = { updateCompareBar };

  function buildCompareBar() {
    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    const compareMap = selectedCompareProducts.map((compare) => ({
      featured_image: compare.featured_image,
      id: compare.id,
      title: compare.title,
      handle: compare.handle,
      sku: compare.sku,
    }));

    return `
         <div class="collection__compare__bar" style='display: flex;'>
             <div class="compareBarContents" style='padding: 6px 0;'>
                 <div style="display: flex; align-items: center; gap: 20px;" class="js-compare-elements-anchor">
                 <p class="collection__compare__bar--text">
                 ${
                   selectedCompareProducts.length > 1
                     ? `<p class="collection__compare__bar--text compare__selected">
                       ${selectedCompareProducts.length} selected
                     </p>`
                     : `<p class="collection__compare__bar--text compare__selected">
                      Compare up to 10 products
                     </p>`
                 }
                 <div class="collection__compare__bar--flex">
                 ${compareMap
                   .map(
                     (compare) => `<div class='compare__and__sku--container'>
                                    <div class='compare__and__sku--wrapper'>
                                      <div class="collection__compare__bar--images">
                                        <a href="/products/${compare.handle}">
                                          <img src=${compare.featured_image} class="collection__compare__bar--selected__product" alt='${compare.title}'/>
                                        </a>
                                        <div style='position:relative; top-0; left-[8px];'>
                                          <button class="collection__compare__bar--x js-removeProductFromCompare" data-id="${compare.id}" id="${compare.id}-removeProductFromCompare" aria-label='remove from compare list'>
                                            <svg 
                                              xmlns="http://www.w3.org/2000/svg" 
                                              fill="#575757" 
                                              width="100%" 
                                              height="100%" 
                                              version="1.1" 
                                              viewBox="144 144 512 512"  
                                              aria-label='x icon'
                                            >
                                              <path d="m563.32 236.68c-26.852-26.84-59.91-46.645-96.246-57.66-36.336-11.016-74.828-12.902-112.07-5.4922-37.238 7.4102-72.074 23.891-101.42 47.977-29.348 24.086-52.305 55.039-66.84 90.117-14.531 35.078-20.188 73.199-16.469 110.98 3.7148 37.785 16.691 74.07 37.781 105.64 21.086 31.574 49.637 57.461 83.117 75.367s70.859 27.281 108.83 27.293c61.219 0.078125 119.96-24.16 163.32-67.383 21.484-21.449 38.531-46.922 50.16-74.965 11.629-28.043 17.617-58.102 17.617-88.461 0-30.355-5.9883-60.418-17.617-88.457-11.629-28.043-28.676-53.516-50.16-74.965zm-74.312 222.73c3.9102 3.9336 6.1055 9.2539 6.1055 14.801 0 5.543-2.1953 10.863-6.1055 14.797-3.9297 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055l-59.406-59.406-59.41 59.406c-3.9336 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055-3.9102-3.9336-6.1055-9.2539-6.1055-14.797 0-5.5469 2.1953-10.867 6.1055-14.801l59.406-59.406-59.406-59.41c-3.4375-4.0156-5.2344-9.1797-5.0312-14.465 0.20312-5.2812 2.3945-10.293 6.1328-14.031s8.75-5.9297 14.031-6.1328c5.2852-0.20313 10.449 1.5938 14.465 5.0312l59.41 59.406 59.406-59.406c1.8828-2.1992 4.1992-3.9805 6.8008-5.2422 2.6055-1.2617 5.4414-1.9688 8.3359-2.0781 2.8906-0.11328 5.7695 0.375 8.4648 1.4297 2.6953 1.0547 5.1406 2.6562 7.1875 4.7031 2.043 2.043 3.6445 4.4922 4.7031 7.1836 1.0508 2.6953 1.5391 5.5781 1.4297 8.4688-0.11328 2.8906-0.82031 5.7266-2.082 8.332-1.2578 2.6055-3.043 4.9219-5.2422 6.8008l-59.406 59.41z"/>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                      <div class='product__identifier--collection'  aria-label='SKU'>${compare.sku}</div>
                                    </div>
                                  </div>
                                  `
                   )
                   .join('\n')}
                   ${
                     selectedCompareProducts.length > 5
                       ? `<div class="collection__compare__bar--five__items__showing">+${
                           selectedCompareProducts.length - 5
                         }</div>`
                       : ''
                   }
                   ${
                     selectedCompareProducts.length > 2
                       ? `<div class="collection__compare__bar--two__items__showing">+${
                           selectedCompareProducts.length - 2
                         }</div>`
                       : ''
                   }
                   ${
                     selectedCompareProducts.length > 1
                       ? `<div class="collection__compare__bar--one__item__showing">+${
                           selectedCompareProducts.length - 1
                         }</div>`
                       : ''
                   }
                     </div>
                     <div style='display: flex; gap: 10px;'>
                      <button class='collection__compare__bar--products__button js-compareButton' tabindex='0'>Compare</button>
                      <button class='collection__compare__bar--products__button js-hideCompareButton' tabindex='0'>Hide</button>
                     </div>
                 </div>
             </div>
         </div>
         `;
  }

  function toggleNoCollectionResults(show) {
    if (show) {
      document.querySelector('.collection__no-results--collection').style.display = 'block';
      loadMoreBtn.style.display = 'none';
    } else {
      document.querySelector('.collection__no-results--collection').style.display = '';
    }
  }
  function toggleNoFilteredResults(show) {
    if (show) {
      document.querySelector('.collection__no-results--filter').style.display = 'block';
      loadMoreBtn.style.display = 'none';
    } else {
      document.querySelector('.collection__no-results--filter').style.display = '';
    }
  }
  function truncate(title) {
    if (title.length > 75) return title.substr(0, 75).trim() + '...';
    else return title;
  }

  function listenToCompareBar() {
    /* remove product from compare selection with x button */
    const removeProductFromCompare = Array.from(document.querySelectorAll('.js-removeProductFromCompare'));
    for (const remover of removeProductFromCompare) {
      remover.addEventListener('click', () => {
        window.compareSlideOutHelper?.findIndex(remover.dataset.id);
        window.compareSlideOutHelper?.removeFromCompare(remover.dataset.id);
        updateCompareBar();
        window.compareModal?.init();
      });
    }

    const compareButtons = Array.from(document.querySelectorAll('.js-compareButton'));
    for (const compareButton of compareButtons) {
      compareButton.addEventListener('click', () => {
        window.compareModal?.init();
        window.compareSlideOutHelper?.toggleModal();
        window.wishlistHelper?.check();
        document.querySelector('html').classList.add('stop-scroll');
      });
    }
    const hideButtons = Array.from(document.querySelectorAll('.js-hideCompareButton'));
    for (const hideButton of hideButtons) {
      hideButton.addEventListener('click', () => {
        window.compareBanner?.hideCompareBar();
      });
    }
  } // end of listenToCompareBar

  function listenToWishlistContainer() {
    const wishlistContainer = document.querySelector('.favorites__banner--container');
    wishlistContainer.addEventListener('mouseenter', () => {
      clearTimeout(hideBannerTimeout);
    });
    wishlistContainer.addEventListener('mouseleave', () => {
      hideBannerTimeout = setTimeout(() => {
        document.querySelector('.favorites__banner--container').classList.remove('favorites__banner--visible');
      }, 2000);
    });
  }

  function listenToCompareCheckboxes() {
    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    /* if product is selected with checkbox, add to compare selection list in local storage. Limit of 10 products */
    const productSelects = Array.from(document.querySelectorAll('.js-compareCheckbox'));
    for (const productSelect of productSelects) {
      const [id, title, featured_image, handle, sku] = productSelect.value.split('|');
      const parsedProduct = { id, title, featured_image, handle, sku };
      const foundSelectedProduct = selectedCompareProducts.find((product) => product.id == parsedProduct.id);
      if (foundSelectedProduct) {
        productSelect.checked = true;
      }
      productSelect.addEventListener('input', function (e) {
        if (e.target.checked) {
          const currentSelectedProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
          if (currentSelectedProducts.length === 10) {
            e.target.checked = false;
            return;
          }
          if (currentSelectedProducts.length < 10) {
            window.compareSlideOutHelper?.addToCompare(parsedProduct);
          }
        } else {
          window.compareSlideOutHelper?.findIndex(parsedProduct.id);
          window.compareSlideOutHelper?.removeFromCompare(parsedProduct.id);
        }
        updateCompareBar();
        //localStorage.setItem('selectedCompareProducts', JSON.stringify(selectedCompareProducts));
        window.compareModal?.init();
        window.compareSlideOutHelper?.refresh();
      });
    }
  }

  function listen() {
    const handleClick = function () {
      if (document.querySelector('.collection__hero').getBoundingClientRect().bottom < 0) {
        document.querySelector('.collection__product-count').scrollIntoView({ behavior: 'smooth' });
      }
      fetchAndRenderCards({ reset: true });
    };
    const inputs = [
      ...Array.from(document.querySelectorAll('input.js-tag')),
      ...Array.from(document.querySelectorAll('input.js-vendor')),
    ];
    for (let input of inputs) {
      input.addEventListener('click', () => {
        handleClick();
      });
    }
    const rangeSliders = Array.from(document.querySelectorAll('.js-range-slider .range-slider__inner'));
    for (let slider of rangeSliders) {
      let sliderTimeout = setTimeout(() => {}, 0);
      const sliderParent = slider.parentNode;
      const sliderInputs = Array.from(slider.querySelectorAll('input'));
      const labels = Array.from(slider.querySelectorAll('.range-slider__display'));
      sliderInputs.forEach((input) => {
        updateSliderVisuals(undefined, sliderParent.dataset.groupName === 'Price');
        input.addEventListener('input', ({ target }) => {
          clearTimeout(sliderTimeout);
          updateSliderVisuals(target, sliderParent.dataset.groupName === 'Price');
          sliderTimeout = setTimeout(() => {
            fetchAndRenderCards({ reset: true });
          }, 500);
        });
        input.addEventListener('change', ({ target }) => {
          clearTimeout(sliderTimeout);
          updateSliderVisuals(target, sliderParent.dataset.groupName === 'Price');
          sliderTimeout = setTimeout(() => {
            fetchAndRenderCards({ reset: true });
          }, 500);
        });
      });
      function updateSliderVisuals(target, isPrice) {
        const [low, high] = sliderInputs;
        const [lowLabel, highLabel] = labels;
        if (parseFloat(low.value) > parseFloat(high.value) - parseFloat(high.max) * 0.15) {
          lowLabel.classList.add('range-slider__display--low--close');
          highLabel.classList.add('range-slider__display--high--close');
        } else {
          lowLabel.classList.remove('range-slider__display--low--close');
          highLabel.classList.remove('range-slider__display--high--close');
        }
        if (target) {
          if (target === low) {
            if (parseFloat(low.value) > parseFloat(high.value) - parseFloat(high.max) * 0.01) {
              low.value = parseFloat(high.value) - parseFloat(high.max) * 0.01;
            }
          }
          if (target === high) {
            if (parseFloat(high.value) < parseFloat(low.value) + parseFloat(low.max) * 0.01) {
              high.value = parseFloat(low.value) + parseFloat(low.max) * 0.01;
            }
          }
        }
        slider.style.background = `linear-gradient(
          to right,
          transparent ${(parseFloat(low.value) / parseFloat(low.max)) * 100}%,
          var(--blue) ${(parseFloat(low.value) / parseFloat(low.max)) * 100}%,
          var(--blue) ${(parseFloat(high.value) / parseFloat(high.max)) * 100}%,
          transparent ${(parseFloat(high.value) / parseFloat(high.max)) * 100}%
        )`;
        lowLabel.style.left = `calc(${(parseFloat(low.value) / parseFloat(low.max)) * 100 + '%'} + ${
          10 - (parseFloat(low.value) / parseFloat(low.max)) * 20 + 'px'
        })`;
        lowLabel.children[0].innerText = isPrice
          ? moneyFormatter.format(low.value).replaceAll('.00', '')
          : numberWithCommas(low.value);
        highLabel.style.right = `calc(${100 - (parseFloat(high.value) / parseFloat(high.max)) * 100 + '%'} - ${
          10 - (parseFloat(high.value) / parseFloat(high.max)) * 20 + 'px'
        })`;
        highLabel.children[0].innerText = isPrice
          ? moneyFormatter.format(high.value).replaceAll('.00', '')
          : numberWithCommas(high.value);
      }
    }
    const handleChangeRange = ({ target }) => {
      const parent = target.parentNode.parentNode;
      const relatedInputs = Array.from(parent.querySelectorAll('.js-range-input'));
      const [lowInput, highInput] = relatedInputs;
      if (target == lowInput) {
        if (parseFloat(target.value) > parseFloat(highInput.value)) {
          target.value = highInput.value;
        }
      }
      if (target == highInput) {
        if (parseFloat(target.value) < parseFloat(lowInput.value)) {
          target.value = lowInput.value;
        }
      }
      fetchAndRenderCards({ reset: true });
    };
    const rangeInputs = Array.from(document.querySelectorAll('.js-range-input'));
    for (let range of rangeInputs) {
      range.addEventListener('change', handleChangeRange);
    }
    loadMoreBtn.addEventListener('click', () => {
      loadMoreBtn.innerText = 'loading...';
      const urlSearchParams = new URLSearchParams(window.location.search);
      const queryParams = Object.fromEntries(urlSearchParams.entries());
      const page = queryParams.page ? parseInt(queryParams.page) + 1 : 1;
      fetchAndRenderCards({ reset: false, page });
    });

    const reviewToggles = document.querySelectorAll("input[name='review_rating']");
    reviewToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        if (e.target.classList.contains('collections__filter__reviews--checked')) {
          reviewToggles.forEach((t) => t.classList.remove('collections__filter__reviews--checked'));
          e.target.checked = false;
          e.target.classList.remove('collections__filter__reviews--checked');
        } else {
          reviewToggles.forEach((t) => t.classList.remove('collections__filter__reviews--checked'));
          e.target.checked = true;
          e.target.classList.add('collections__filter__reviews--checked');
        }
        if (document.querySelector('.collection__hero').getBoundingClientRect().bottom < 0) {
          document.querySelector('.collection__product-count').scrollIntoView({ behavior: 'smooth' });
        }
        fetchAndRenderCards({ reset: true });
      });
    });
    const filterToggles = Array.from(document.querySelectorAll('.js-filter-toggle'));
    filterToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (toggle.classList.contains('js-filter-toggle--open')) {
          filterToggles.forEach((t) => {
            t.classList.remove('js-filter-toggle--open');
            t.nextElementSibling.classList.remove('js-filter-toggle--open');
          });
        } else {
          filterToggles.forEach((t) => {
            t.classList.remove('js-filter-toggle--open');
            t.nextElementSibling.classList.remove('js-filter-toggle--open');
          });
          toggle.classList.add('js-filter-toggle--open');
          toggle.nextElementSibling.classList.add('js-filter-toggle--open');
        }
      });
    });
    window.addEventListener('click', (e) => {
      const filterBox = document.querySelector('.collection__filters');
      if (!filterBox.contains(e.target)) {
        filterToggles.forEach((t) => {
          t.classList.remove('js-filter-toggle--open');
          t.nextElementSibling.classList.remove('js-filter-toggle--open');
        });
      }
    });

    function stickyBars() {
      const filterSortHeight = document.querySelector('.collection__filter-sort').getBoundingClientRect().height;
      const calculatedHeight = filterSortHeight + `px`;

      const root = document.querySelector(':root');

      if (
        window.innerWidth > 1180 &&
        document.querySelector('.collection__filter-sort').getBoundingClientRect().top <= 0
      ) {
        // document.querySelector('.collection__filter-sort').style.boxShadow = '0 0 10px rgba(0, 0, 0, 0.2)';
        document.querySelector('.collection__compare__bar').style.boxShadow = '0 10px rgba(0, 0, 0, 0.2)';
        document.querySelector('.collection__filter-sort').style.padding = '8px';
        document.querySelector('.collection__compare__bar').style.padding = '0 8px';
        document.querySelector('.collection__compare-products').style.backgroundColor = '#EEEEEE';
        document.querySelector('.collection__compare-products').style.top = calculatedHeight;
        // document.querySelector('.collection__compare-products').style.top = calculatedHeight;
        root.style.setProperty('--transition', 0);
        // console.log('true, is it scrolled');
      } else {
        document.querySelector('.collection__compare__bar').style.boxShadow = '';
        document.querySelector('.collection__filter-sort').style.padding = '';
        window.compareWithHeader?.compareBarPosition();
        document.querySelector('.collection__compare__bar').style.padding = '';
        root.style.setProperty('--transition', '.3s');
        // console.log('false, it is at the top');
      }
    }

    window.addEventListener(
      'scroll',
      () => {
        stickyBars();
      },
      { passive: true }
    );

    Array.from(document.querySelectorAll('.js-filter-close-desktop')).forEach((button) => {
      button.addEventListener('click', () => {
        filterToggles.forEach((t) => {
          t.classList.remove('js-filter-toggle--open');
          t.nextElementSibling.classList.remove('js-filter-toggle--open');
          t.nextElementSibling.style.maxHeight = '';
        });
      });
    });
    document.querySelector('.collection__sort__select').addEventListener('change', () => {
      fetchAndRenderCards({ reset: true });
    });
    document.querySelector('.js-filter-show').addEventListener('click', () => {
      document.querySelector('.collection__filters').style.zIndex = 10;
      document.querySelector('.collection__filters').style.display = 'flex';
    });
    document.querySelector('.js-filter-apply').addEventListener('click', () => {
      document.querySelector('.collection__filters').style.zIndex = '';
      document.querySelector('.collection__filters').style.display = '';
    });
  }
  function getParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
    const page = queryParams.page ? queryParams.page : 1;
    const filters = queryParams.tags ? queryParams.tags : '';
    const vendors = queryParams.vendor ? queryParams.vendor : '';
    const price = queryParams.price ? queryParams.price : '';
    const rating = queryParams.review_rating ? queryParams.review_rating : '';
    const sort = queryParams.order_by ? queryParams.order_by : '';

    return {
      page,
      filters,
      vendors,
      price,
      rating,
      sort,
    };
  }
  function buildFetchFromParams() {
    return buildFetchUrl({
      include_filters: true,
      params: getParams(),
    });
  }
  function buildFetchFromBoxes(page = 1) {
    const checkboxesAndRadios = Array.from(document.querySelectorAll('input.js-tag:checked')).map((v) => v.value);
    const ranges = Array.from(document.querySelectorAll('.js-range-slider'))
      .map((v) => {
        if (v.dataset.groupName === 'Price') {
          return;
        }
        const [lowElement, highElement] = Array.from(v.querySelectorAll('input'));
        const groupName = v.dataset.groupName;
        const defaultMin = v.dataset.min;
        const defaultMax = v.dataset.max;
        const currentMin = lowElement.value;
        const currentMax = highElement.value;

        if (defaultMin !== currentMin || defaultMax !== currentMax) {
          return `r__${groupName}__${currentMin}-${currentMax}`;
        }
      })
      .filter((v) => v);
    const filters = [...checkboxesAndRadios, ...ranges].join(',');
    const vendors = Array.from(document.querySelectorAll('input.js-vendor:checked'))
      .map((v) => v.value)
      .join(',');

    const price = [
      (document.querySelector('#min-Price').value || '').replace('$', ''),
      (document.querySelector('#max-Price').value || '').replace('$', ''),
    ]
      .filter((v) => v)
      .join(',');
    const rating = (document.querySelector("input[name='review_rating']:checked") || {}).value || '';
    const sort = (document.querySelector('.collection__sort__select') || {}).value || 'rank-asc';

    return buildFetchUrl({
      include_filters: false,
      params: {
        page,
        filters,
        vendors,
        price,
        rating,
        sort,
        append_results: true,
      },
    });
  }
  function buildFetchUrl(
    { include_filters = false, params: { page = 1, filters, vendors, price, rating, sort, append_results } } = {
      params: {},
    }
  ) {
    const params = `page=${page}${filters ? `&tags=${filters}` : ''}${vendors ? `&vendor=${vendors}` : ''}${
      price ? `&price=${price}` : ''
    }${rating ? `&review_rating=${rating}` : ''}${sort ? `&order_by=${sort}` : ''}${
      append_results ? '&append_results=true' : ''
    }`;
    const currentFetchUrl = `${BASE_URL}${include_filters ? '&include_filters=true' : ''}&${params}`;
    window.history.pushState(null, '', `?${params}`);

    return currentFetchUrl;
  }
  function checkActiveBoxesFromParams({ filters, vendors, price, rating, sort } = {}) {
    if (filters) {
      for (const filter of filters.split(',')) {
        if (filter[0] === 'r') {
          const [type, groupName, values] = filter.split('__');
          const [low, high] = values.split('-');
          if (low && document.querySelector(`input[id="min-${groupName}"]`)) {
            document.querySelector(`input[id="min-${groupName}"]`).value = low;
          }
          if (high && document.querySelector(`input[id="max-${groupName}"]`)) {
            document.querySelector(`input[id="max-${groupName}"]`).value = high;
          }
        } else {
          (document.querySelector(`input[value="${filter}"]`) || {}).checked = true;
        }
      }
    }
    if (vendors) {
      for (const vendor of vendors.split(',')) {
        (document.querySelector(`input[value="${vendor}"]`) || {}).checked = true;
      }
    }
    if (rating) {
      (document.querySelector(`input[value="${rating}"]`) || {}).checked = true;
    }
    if (sort && document.querySelector('.collection__sort__select')) {
      document.querySelector('.collection__sort__select').value = sort;
    }
    if (price) {
      const [low, high] = price.split(',');
      if (low && !isNaN(low) && high && !isNaN(high)) {
        if (document.querySelector('#min-Price')) {
          document.querySelector('#min-Price').value = low;
        }
        if (document.querySelector('#max-Price')) {
          document.querySelector('#max-Price').value = high;
        }
      }
      document.querySelector('#max-Price').dispatchEvent(new Event('input'));
      document.querySelector('#min-Price').dispatchEvent(new Event('input'));
    }
  }
  function buildActiveFilters() {
    const tagButtons = Array.from(document.querySelectorAll('.js-tag:checked')).map((el) => {
      return `
        <button class="collection__filter__remover js-filter-remover" data-value="${el.value}">${el.nextElementSibling.innerText} <span class="collection__filter__remover--x">&times;</span></button>
      `;
    });
    const vendorButtons = Array.from(document.querySelectorAll('.js-vendor:checked')).map((el) => {
      return `
        <button class="collection__filter__remover js-filter-remover" data-value="${el.value}">${el.nextElementSibling.innerText} <span class="collection__filter__remover--x">&times;</span></button>
      `;
    });
    const rangeValues = Array.from(document.querySelectorAll('.js-range-slider')).map((el) => {
      const inputs = Array.from(el.querySelectorAll('input'));
      const [lowInput, highInput] = inputs;
      const showRange = lowInput.min !== lowInput.value || highInput.max !== highInput.value;
      if (showRange) {
        const lowValue =
          el.dataset.groupName === 'Price'
            ? moneyFormatter.format(lowInput.value).replaceAll('.00', '')
            : lowInput.value;
        const highValue =
          el.dataset.groupName === 'Price'
            ? moneyFormatter.format(highInput.value).replaceAll('.00', '')
            : highInput.value;
        return `
          <button class="collection__filter__remover js-range-remover" data-group-name="${el.dataset.groupName}">
            ${el.dataset.groupName} ${lowValue} - ${highValue}
            <span class="collection__filter__remover--x">&times;</span>
          </button>
        `;
      }
      return '';
    });
    let reviewButton = '';
    if (Array.from(document.querySelectorAll('input[name="review_rating"]:checked')).length > 0) {
      const rating = Array.from(document.querySelectorAll('input[name="review_rating"]:checked'))[0].value;
      reviewButton = `<button class="collection__filter__remover js-filter-remover" data-value="${rating}">${rating} star${
        rating < 5 ? ' &amp; up' : ''
      } <span class="collection__filter__remover--x">&times;</span></button>`;
    }
    document.querySelector('.collection__active__filters').innerHTML = `
      ${tagButtons.join('\n')}
      ${vendorButtons.join('\n')}
      ${rangeValues.join('\n')}
      ${reviewButton}
    `;
    Array.from(document.querySelectorAll('.js-filter-remover')).forEach((btn) =>
      btn.addEventListener('click', () => {
        document.querySelector(`input[value='${btn.dataset.value}']`).click();
      })
    );
    Array.from(document.querySelectorAll('.js-range-remover')).forEach((btn) =>
      btn.addEventListener('click', () => {
        const parent = document.querySelector(`.js-range-slider[data-group-name="${btn.dataset.groupName}"]`);
        const [lowInput, highInput] = Array.from(parent.querySelectorAll('input'));
        lowInput.value = parent.dataset.min;
        highInput.value = parent.dataset.max;
        lowInput.dispatchEvent(new Event('change'));
        btn.remove();
      })
    );
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();
